import { Popover } from '@radix-ui/react-popover';
import React, { useState } from 'react';

import { FlatDropdownContextProvider } from './context';

const FlatDropdownRoot: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);

  return (
    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <FlatDropdownContextProvider
        isOpen={isPopoverOpen}
        setIsOpen={setIsPopoverOpen}>
        {children}
      </FlatDropdownContextProvider>
    </Popover>
  );
};

export default FlatDropdownRoot;
